// Text constants for internationalization
// This file centralizes all text content used throughout the application

export const TEXT_CONSTANTS = {
  APP: {
    NAME: 'Airo Lounge',
    TAGLINE: 'Airo Intranet Portal',
    DESCRIPTION: 'Your one-stop shop for internal projects and organization information.',
  },

  // Common UI text
  COMMON: {
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    SUBMIT: 'Submit',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    EDIT: 'Edit',
    DELETE: 'Delete',
    BACK: 'Back',
    NEXT: 'Next',
    PREVIOUS: 'Previous',
    LOADING: 'Loading...',
    ERROR: 'Error',
    SUCCESS: 'Success',
    WARNING: 'Warning',
    INFO: 'Information',
    CONFIRM: 'Confirm',
    YES: 'Yes',
    NO: 'No',
    OK: 'OK',
    CLOSE: 'Close',
  },

  // Authentication related text
  AUTH: {
    LOGIN_TITLE: 'Airo Lounge',
    LOGIN_SUBTITLE: 'Airo Intranet Portal',
    LOGIN_MOTTO: 'Your one-stop shop for internal projects and organization information. Connect, collaborate, and stay in the loop with everything Airo.',
    EMAIL_LABEL: 'Work Email Address',
    EMAIL_PLACEHOLDER: 'name@airodigitallabs.com',
    PASSWORD_LABEL: 'Password',
    PASSWORD_PLACEHOLDER: 'Enter your password',
    REMEMBER_ME: 'Remember me',
    FORGOT_PASSWORD: 'Forgot password?',
    LOGIN_BUTTON: 'Sign In',
    GMAIL_SIGNIN_BUTTON: 'Sign in with Gmail',
    LOGIN_SUCCESS: 'Login successful!',
    LOGIN_ERROR: 'Login failed. Please check your credentials.',
    EMAIL_REQUIRED: 'Email is required',
    PASSWORD_REQUIRED: 'Password is required',
    INVALID_EMAIL: 'Please enter a valid Airo Digital Labs email address',
    PASSWORD_MIN_LENGTH: 'Password must be at least 6 characters',
    OR_DIVIDER: 'OR',
  },

  // Navigation text
  NAVIGATION: {
    HOME: 'Home',
    DASHBOARD: 'Dashboard',
    PROFILE: 'Profile',
    SETTINGS: 'Settings',
    HELP: 'Help',
    ABOUT: 'About',
  },

  // Form validation messages
  VALIDATION: {
    REQUIRED_FIELD: 'This field is required',
    INVALID_FORMAT: 'Invalid format',
    MIN_LENGTH: 'Minimum length is {min} characters',
    MAX_LENGTH: 'Maximum length is {max} characters',
    PASSWORD_MISMATCH: 'Passwords do not match',
    INVALID_PHONE: 'Please enter a valid phone number',
    INVALID_URL: 'Please enter a valid URL',
  },

  // Error messages
  ERRORS: {
    NETWORK_ERROR: 'Network error. Please check your connection.',
    SERVER_ERROR: 'Server error. Please try again later.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
    FORBIDDEN: 'Access denied.',
    NOT_FOUND: 'The requested resource was not found.',
    VALIDATION_ERROR: 'Please check your input and try again.',
    UNKNOWN_ERROR: 'An unknown error occurred.',
  },

  // Success messages
  SUCCESS: {
    DATA_SAVED: 'Data saved successfully',
    DATA_UPDATED: 'Data updated successfully',
    DATA_DELETED: 'Data deleted successfully',
    OPERATION_COMPLETED: 'Operation completed successfully',
  },

  // Know Your Colleague specific text
  KYC: {
    TITLE: 'Know Your Colleague',
    SUBTITLE: 'Connect, Collaborate, and Discover',
    PERSONAL_INFO: 'Employee Profile',
    SKILLS_PROFILE: 'Skills & Expertise',
    PROJECT_EXPERIENCE: 'Project Experience',
    COLLEAGUE_CONNECTIONS: 'Colleague Connections',
    UPLOAD_RESUME: 'Upload Resume',
    UPDATE_PROFILE: 'Update Profile',
    PROFILE_PENDING: 'Profile Pending Review',
    PROFILE_APPROVED: 'Profile Complete',
    PROFILE_INCOMPLETE: 'Profile Incomplete',
    FIND_COLLEAGUES: 'Find Colleagues',
    SHARED_INTERESTS: 'Shared Interests',
    PROJECT_MATCHES: 'Project Matches',
  },

  // Placeholder text
  PLACEHOLDERS: {
    SEARCH: 'Search...',
    SELECT_OPTION: 'Select an option',
    ENTER_TEXT: 'Enter text here',
    UPLOAD_FILE: 'Upload file',
  },

  // Button text
  BUTTONS: {
    UPLOAD: 'Upload',
    DOWNLOAD: 'Download',
    VIEW: 'View',
    EDIT: 'Edit',
    DELETE: 'Delete',
    APPROVE: 'Approve',
    REJECT: 'Reject',
    SUBMIT: 'Submit',
    RESET: 'Reset',
    CLEAR: 'Clear',
  },
};

// Helper function to get text with parameters
export const getTextWithParams = (text, params = {}) => {
  let result = text;
  Object.keys(params).forEach(key => {
    result = result.replace(`{${key}}`, params[key]);
  });
  return result;
};

// Helper function to get nested text
export const getText = (path) => {
  const keys = path.split('.');
  let result = TEXT_CONSTANTS;
  
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      console.warn(`Text constant not found: ${path}`);
      return path; // Return the path if not found
    }
  }
  
  return result;
};

export default TEXT_CONSTANTS;
